import React from "react";
import { observer } from "mobx-react";

import { Bet } from "@models";
import MyBetsViewStore from "@state/stores/my-bets/MyBetsViewStore";

export default observer(function OpenSingleBet(props: {
	bet: Bet;
	myBetsViewStore: MyBetsViewStore;
}) {
	return (
		<button
			type="button"
			className="widget--bets__more btn btn--square btn--square--xsml btn--primary--inverted btn--animate-forward"
			onClick={() => props.myBetsViewStore.onOpen(props.bet.id)}
		>
			<i className="u-icon u-icon--tny u-icon--arrow-right" />
		</button>
	);
});
